// Calculates the menu position (downwards by default, upwards if needed).
export function getMenuPosition({ buttonRef, menuRef, menuWidth }) {
    if (!buttonRef.current) {
        return { top: 0, left: 0 };
    }
    const buttonRect = buttonRef.current.getBoundingClientRect();
    const left = buttonRect.right - menuWidth + window.scrollX;
    let top = buttonRect.bottom + window.scrollY;

    if (menuRef.current) {
        const menuHeight = menuRef.current.offsetHeight;
        const viewportHeight = window.innerHeight;
        if (buttonRect.bottom + menuHeight > viewportHeight) {
            top = buttonRect.top + window.scrollY - menuHeight;
        }
    }
    return { top, left };
}

// Checks if the button is visible inside the scrollable container.
export function isButtonVisibleInContainer(buttonRef, container) {
    if (!buttonRef.current || !container) {
        return false;
    }
    const buttonRect = buttonRef.current.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    return (
        buttonRect.bottom > containerRect.top &&
        buttonRect.top < containerRect.bottom &&
        buttonRect.right > containerRect.left &&
        buttonRect.left < containerRect.right
    );
}
